import { render, staticRenderFns } from "./b-products.vue?vue&type=template&id=1a02fd0a&scoped=true"
import script from "./b-products.vue?vue&type=script&lang=ts"
export * from "./b-products.vue?vue&type=script&lang=ts"
import style0 from "./b-products.vue?vue&type=style&index=0&id=1a02fd0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02fd0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a02fd0a')) {
      api.createRecord('1a02fd0a', component.options)
    } else {
      api.reload('1a02fd0a', component.options)
    }
    module.hot.accept("./b-products.vue?vue&type=template&id=1a02fd0a&scoped=true", function () {
      api.rerender('1a02fd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/biz/b-products.vue"
export default component.exports